import swal  from 'sweetalert2';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Municipio } from '../../entities/municipios';
import { DireccionService } from '../../services/direccion.service';
import { Subject } from 'rxjs';
import { Barrio } from '../../entities/Barrio';
import { Edificio } from '../../entities/edificio';
import { DireccionServicioComponent } from 'app/modals/direccion-servicio/direccion-servicio.component';
import { BarrioComponent } from '../barrio/barrio.component';
import { EdificioComponent } from '../edificio/edificio.component';
import { Direccion } from '../../entities/direccion';

@Component ({
    selector: 'app-direccion',
    templateUrl: './direccion.component.html',
    styleUrls: ['./direccion.component.scss']
})
export class DireccionComponent implements OnInit, OnDestroy {
    public municipios: Array<Municipio>;
    public formulario: FormGroup;
    public subject: Subject<void>;
    public barrios: Array<Barrio>;
    public edificios: Array<Edificio>;
    public isValid:boolean;
    // Constructor para la inyeccion de dependencias
    constructor( private _fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private _data, private _dirService: DireccionService, private _mat: MatDialog ) {
        this.formulario = this._fb.group({
            direccionRegistradaAntigua:[this._data.actual_direccion],
            tipoVia: [''],
            numeroPrincipal: [''],
            numeroSecundario: [''],
            numeroTernario: [''],
            ciudad: [''],
            barrio: [''],
            comuna: [''],
            esEdificio:[false],
            edificio: [''],
            tipoInmueble: [''],
            tipoInmuebleNro: [''],
            bloqueInterior: [''],
            bloqueInteriorNro: [''],
            lat: [],
            lng: [],
            observaciones:[],
            usuarioActivo:[''],
            validado:[false],
            parqueadero:[true]
        });
    }

    // Evento que se dispara al abrir el modal
    ngOnInit(): void{
        console.log(this._data);
        if(this._data.tipoDir == "beneficiario"){
            this._dirService.direccionDeUnBeneficiario(this._data.key).subscribe(succ=>this.setFormValue(succ));
        }else if(this._data.tipoDir== "servicio"){
            this._dirService.direccionDeUnServicio(this._data.key).subscribe(succ=>this.setFormValue(succ));
        } else if (this._data.tipoDir == "titular"){
            // this._dirService.
            let log;
        }
        this._dirService.getCiudades()
            .subscribe(ciudades => this.municipios = ciudades);
    }
    // Asignar data a formulario
    setFormValue(value:Direccion){
        if(value.direccionRegistradaAntigua === null){
            this.formulario.get("direccionRegistradaAntigua").setValue(this._data.actual_direccion);
            return;
        }
        value.usuarioActivo = JSON.parse(localStorage.getItem("usuario")).id_usuario;
        this.formulario.setValue(value);
        this.loadBarrios();
        this.loadEdificios();
    }

    // En caso de que se cierre el modal destruir todos los observadores
    ngOnDestroy(): void {
        this.subject = new Subject();
        this.subject.unsubscribe();
    }

    // Obtiene todos los barrios que están relacionados a la ciudad seleccionada
    loadBarrios(): void{
        // tslint:disable-next-line: curly
        if(this.formulario.get("ciudad").value === "") return;
        this._dirService.getBarriosOfACity(this.formulario.get("ciudad").value)
            .subscribe(barrios => {this.barrios = barrios;this.loadEdificios();});
    }
    loadEdificios(): void{
        // tslint:disable-next-line: curly
        if (this.formulario.get("barrio").value === "") return;
        const comuna: Barrio = (this.barrios)? this.barrios.find(barrio => {
            // tslint:disable-next-line: triple-equals
            return barrio.id_barrio == this.formulario.get("barrio").value;
        }):{id_barrio:null,nombre_barrio:null,comuna:null};
        this.formulario.get('comuna').setValue(comuna.comuna);
        // this.formulario.get("comuna").setValue();
        this._dirService.getEdificiosOfABarrio(this.formulario.get("barrio").value)
            .subscribe(edificios => this.edificios = edificios);
    }

    // Abre el modal de coordenadas y guarda las cordenadas devueltas por el mismo
    coordenadas(){
        const modalCoords: MatDialogRef<DireccionServicioComponent> = this._mat.open(DireccionServicioComponent, {
            width:'70%',
            height:'90%',
            data:{
                coords:{
                    lat:this.formulario.get("lat").value,
                    lng:this.formulario.get("lng").value
                }
            },
            disableClose:true
        });
        //Cuando se cierra el modal caputa las coordenadas tomadas y las mete en una variable
        modalCoords.afterClosed().subscribe((coords:{lat:number, lng:number}) => {
            if(coords){
                this.formulario.get("lat").setValue(coords.lat);
                this.formulario.get("lng").setValue(coords.lng);
            }
        });
    }

    // Modal para crear un nuevo barrio
    newBarrio(){
        let barrio:MatDialogRef<BarrioComponent> = this._mat.open(BarrioComponent,{
            data: {
                city: this.formulario.get("ciudad").value
            }
        });
        barrio.afterClosed().subscribe(succ=>{
            this.loadBarrios();
        })
    }
    //Modal para crear un nuevo edificio
    newEdificio(){
        const nuevoEdificio = this._mat.open(EdificioComponent, {
            data:{
                city:this.formulario.get("ciudad").value,
                barrio:this.formulario.get("barrio").value
            }
        });

        nuevoEdificio.afterClosed()
            .subscribe(evnt=>{
                this.loadEdificios();
            });
    }

    validarDireccion(){
        let control:AbstractControl = this.formulario.get("validado");
        if(!control.value){
            swal.fire({
                title:'Está seguro de lo que hará',
                text:' Esta dirección se guardará cómo validada',
                showCancelButton:true,
            }).then(succ=>{
                if(succ.value){
                    control.setValue(!control.value);
                }
            });
        }else{
            control.setValue(!control.value);
        }
    }
}
